module.exports = __webpack_public_path__ + "img/icon_sportMenu_volleyball.46bc6119.svg";